/**
 * Creates a peanut script element. Uses ES modules when enabled via feature flag.
 * ES modules are singletons, so each script needs a unique URL to trigger execution.
 */
export function createPeanutScript(baseId: string): HTMLScriptElement {
    const script = document.createElement('script');
    const useEsm = NutClientConfig.hasPeanutEsmBuild;

    if (useEsm) {
        const uniqueId = `${baseId}-${Date.now()}`;
        script.src = `/peanut-esm.js?id=${uniqueId}`;
        script.type = 'module';
        script.id = `peanut-script-${uniqueId}`;
    } else {
        script.src = '/peanut.js';
        script.type = 'text/javascript';
        script.id = 'peanut-script';
    }
    script.async = true;

    return script;
}
